import type { GetRequestsListItem } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../types/tables";

import { TABLE_LAYOUT_PRESETS } from "../../constants/columnWidths";
import { accountTagsCell } from "../../helpers/accountTagsCell";
import {
  inlineDueDateCell,
  inlineStatusCell,
} from "../../helpers/cellRenderers";
import {
  accountCell,
  complexityCell,
  createdByCell,
  dateCell,
  designTypeCell,
  nameCell,
} from "../../helpers/commonCells";

// Overdue Tab Configuration for Designer
// Columns: Name, Account, Due, Status, Level, Created by, Created date, Request/Design type
export const designerOverdueTableConfig: TableConfig<GetRequestsListItem> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.name,
    },
    {
      accessor: "account",
      cellRenderer: accountCell,
      header: "Account",
      key: "account",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.account,
    },
    {
      accessor: "dueDate",
      cellRenderer: inlineDueDateCell,
      header: "Due",
      key: "dueDate",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.dueDate,
    },
    {
      accessor: "status",
      cellRenderer: inlineStatusCell,
      header: "Status",
      key: "status",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.status,
    },
    {
      accessor: "complexity",
      cellRenderer: complexityCell,
      header: "Level",
      key: "complexity",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.complexity,
    },
    {
      accessor: "createdBy",
      cellRenderer: createdByCell,
      header: "Created by",
      key: "createdBy",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.createdBy,
    },
    {
      accessor: "createdAt",
      cellRenderer: dateCell,
      header: "Created date",
      key: "createdAt",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.createdAt,
    },
    {
      accessor: "designType",
      cellRenderer: designTypeCell,
      header: "Design Type",
      key: "designType",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.requestType,
    },
    {
      accessor: "account",
      cellRenderer: accountTagsCell,
      header: "Tags",
      key: "accountTags",
      sortable: false,
      width: 150,
    },
  ],
  defaultSort: {
    column: "dueDate",
    direction: "asc",
  },
  enableSorting: true,
  getRowClassName: whitelabelRowClassName,
  id: "designer-overdue-requests",
  title: "Overdue Requests",
};
